/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Email: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M13.4 14.5999C12.989 14.8813 12.4977 15.0217 12 14.9999C11.5023 15.0217 11.011 14.8813 10.6 14.5999L0 8.8999V18.9999C0 19.7956 0.31607 20.5586 0.87868 21.1212C1.44129 21.6838 2.20435 21.9999 3 21.9999H21C21.7956 21.9999 22.5587 21.6838 23.1213 21.1212C23.6839 20.5586 24 19.7956 24 18.9999V8.8999L13.4 14.5999Z'
      fill='currentColor'
    />
    <path
      d='M21 2H3.00001C2.20437 2 1.4413 2.31607 0.878694 2.87868C0.316085 3.44129 1.47444e-05 4.20435 1.47444e-05 5V6C-0.00094077 6.18032 0.0445606 6.35785 0.132135 6.51549C0.219709 6.67312 0.346405 6.80555 0.500015 6.9L11.5 12.9C11.6536 12.9808 11.8272 13.0156 12 13C12.1728 13.0156 12.3465 12.9808 12.5 12.9L23.5 6.9C23.6536 6.80555 23.7803 6.67312 23.8679 6.51549C23.9555 6.35785 24.001 6.18032 24 6V5C24 4.20435 23.6839 3.44129 23.1213 2.87868C22.5587 2.31607 21.7957 2 21 2Z'
      fill='currentColor'
    />
  </React.Fragment>
)
